<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi, { type LegacyDevice } from "@/rvapi";
import UserLookup from "@/components/UserLookup.vue";
import LegacyDeviceDetails from "@/components/LegacyDeviceDetails.vue";

const route = useRoute();
const router = useRouter();
const deviceId = route.params.id as string;
const device = ref(undefined as LegacyDevice | undefined);
const error = ref("");
const loaded = ref(false);
onMounted(async () => {
  const result = await RvApi.searchLegacyDevice(deviceId);
  if (result.length !== 1) {
    error.value = "Invalid legacy device";
    loaded.value = true;
    return;
  }
  device.value = result.find(() => true);
  loaded.value = true;
});
const migrate = async (userId: string) => {
  loaded.value = false;
  const result = await RvApi.migrateBalanceToUser(userId, deviceId, true);
  if (result.balance) {
    router.push(`/user/${userId}`);
  } else {
    error.value = "Did not migrate balance properly.";
    loaded.value = true;
  }
};
</script>

<template>
  <h1>Migrate legacy balance to user</h1>
  <pn-toast
    appearance="error"
    closable="false"
    v-show="error"
    :text="error"
  ></pn-toast>
  <pn-spinner size="4" v-show="!loaded" />
  <section v-show="!!loaded && device">
    <h3>From device</h3>
    <LegacyDeviceDetails :simple="true" :device="device" />

    <pn-toast v-if="!device?.deviceBalance" closable="false">
      Device has no balance!
    </pn-toast>
    <UserLookup v-if="device?.deviceBalance" @userSelected="migrate" />
  </section>
</template>
